import { render, staticRenderFns } from "./addAssemble.vue?vue&type=template&id=0d8a5836&scoped=true"
import script from "./addAssemble.vue?vue&type=script&lang=js"
export * from "./addAssemble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a5836",
  null
  
)

export default component.exports